<template>
  <v-row no-gutters justify="space-between" align="start">
    <v-col cols="6">
      <h5 class="secondary-font">{{ text }}</h5>
      <v-input v-model="model.value" :rules="rules"></v-input>
    </v-col>
    <v-col cols="6">
      <!--  Quando v-mask é um array, por algum motivo, está causando erro de infinite loop
      Então, se for um array, convertemos para spread operator -->
      <v-text-field
        v-if="options && options.mask"
        v-model="model.value"
        :type="type"
        solo
        flat
        v-mask="Array.isArray(options.mask) ? [...options.mask] : options.mask"
        dense
        placeholder="Digite aqui..."
        class="custom-textfield"
        hide-details
      ></v-text-field>
      <v-text-field
        v-else
        v-model="model.value"
        :type="type"
        solo
        flat
        dense
        placeholder="Digite aqui..."
        class="custom-textfield"
        hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" v-if="justify">
      <v-text-field
        v-model="model.text"
        :label="textJustify || 'Comentrários'"
        class="custom-textfield "
        solo
        flat
        dense
        hide-details
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      validator: prop => ['text', 'number', 'date'].includes(prop)
    },
    noRequired: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      required: false
    },
    justify: {
      type: Boolean,
      default: false
    },
    textJustify: {
      type: String,
      default: 'Comentrários'
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    rules() {
      if (this.noRequired) return []

      if (this.type === 'date') {
        return [
          v => new Date(v) <= new Date() || 'A data deve ser anterior ou igual a data de hoje',
          v => v !== null || 'Resposta obrigatória',
          v => !!v || 'Resposta obrigatória'
        ]
      }
      return [v => v !== null || 'Resposta obrigatória', v => !!v || 'Resposta obrigatória']
    }
  }
}
</script>

<style></style>
